import * as yup from 'yup'

import { validates } from 'helpers'

const schema = yup.object({
  name: yup.string().max(255).required(),
  email: yup.string().email().max(255),
  phone: yup.string().min(10).max(15),
  document: yup
    .string()
    .min(14)
    .max(18)
    .test(
      'is-valid-document',
      'O documento fornecido é inválido',
      function (value) {
        return validates.cpfOrCpnj(value)
      }
    ),
  companyName: yup.string().max(255).required(),
  segment: yup.string().max(255).required(),
  employees: yup.string().max(255).required(),
})

export type SolicitationContactModalSchemaType = yup.InferType<typeof schema>
export type SolicitationContactModalControlType =
  keyof SolicitationContactModalSchemaType

export default schema
